<template>
  <div :class="{open: isOpen}" class="notification-center">
    <div class="notification-list">
      <b-container fluid>
        <b-row>
          <b-col cols="10">
            <div class="title">{{ $t('notification.title') }}:</div>
          </b-col>
          <b-col cols="2">
            <b-button
              variant="link"
              class="text-right"
              block
              @click="closePanel"
            >
              <i class="ti ti-close" />
            </b-button>
          </b-col>
        </b-row>
      </b-container>
      <loader v-if="loading" zoom="1" />
      <b-list-group>
        <b-list-group-item
          v-for="(notification, idx) in notifications"
          :key="notification.id"
          @click="read(notification, idx)"
        >
          <one-notification :notification="notification" />
        </b-list-group-item>
        <router-link :to="{name: 'notifications'}" class="text-center mt-2">{{ $t('notification.all') }}</router-link>
      </b-list-group>
    </div>
  </div>
</template>

<script>
  import OneNotification from '@/components/OneNotification';
  import Loader from '@/components/Loader';

  export default {
    name: 'LiveNotificationsComponent',
    components: {
      OneNotification,
      Loader,
    },
    data() {
      return {
        notifications: [],
        isOpen: false,
        loading: true,
        countNotif: 0,
      };
    },
    computed: {
      hasNotifications() {
        return this.countNotif > 0;
      },
    },
    async mounted() {
      if (this.user().memorial) {
        this.$nextTick(this.loadNotifications);
      }

      this.$bus.$on('t-event.toggle-notification-panel', () => {
        this.isOpen = !this.isOpen;
        if (this.isOpen) {
          this.loadNotifications();
        }
      });

      this.$bus.$on('t-event.notification.new', this.loadNotifications);

      this.$bus.$on('t-event.notification.read', (notification) => {
        this.$set(notification, 'read', true);
      });
    },
    destroyed() {
      this.$bus.$off([
        't-event.toggle-notification-panel',
        't-event.notification.new',
        't-event.notification.read',
      ]);
    },
    methods: {
      closePanel() {
        this.$bus.$emit('t-event.toggle-notification-panel');
      },
      notifCounter(notifications) {
        return this._.reduce(notifications, (carry, notification) => carry + Number(!notification.read), 0);
      },
      async loadNotifications() {
        this.loading = true;
        const data = await this.$ajax.get(`api/memorial/${this.user().memorial.id}/notification/?filters[status]=unread`);
        this.loading = false;
        this.notifications = data;
        this.countNotif = this.notifCounter(data);
        this.$bus.$emit('t-event.notification.loaded', { notifications: this.notifications, count: this.countNotif });
      },
      read(notification, idx) {
        const { id } = this.user().memorial;

        this.closePanel();

        this.$router.push({ name: `${notification.kind}.index`, params: { id } });

        if (notification.id && !notification.read) {
          this.notifications.splice(idx, 1);
          this.$ajax.get(`api/memorial/${id}/notification/${notification.id}/read`).then(() => {
            this.$bus.$emit('t-event.notification.read', notification);
          });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
  @import '~@triotech/vue-core/src/scss/compass';
  @import '~@/scss/media';
  @import 'compass/css3/transform';
  @import 'compass/css3/transition';

  .connected {
    .notification-center {
      top: 154px;
    }
  }

  .title {
    color: $grey;
    margin: 10px 0;
  }

  .btn-link {
    padding: 0 !important;
  }

  .list-group-item {
    padding: 0;
    margin-bottom: 5px;
  }

  .notification-center {
    position: fixed;
    right: 0;
    top: $nav-height;
    bottom: 0;
    width: 30%;
    background: $extra-light-grey;
    z-index: 200000;
    border-left: 1px solid $light-grey;
    @include transform(translateX(100%));
    @include transition(transform .2s);

    &.open {
      @include transform(translateX(0%));
    }

    h2 {
      color: $grey;
      font-weight: normal;
      font-size: 18px;
    }

    .notification-list {
      padding: 10px;
      height: 100%;
      overflow: auto;
    }
  }

  @include editable-max-width(767px) {
    .notification-center {
      border-top: 1px solid $light-grey;
      width: 50%;
      top: 56px !important;
    }
  }

  @include editable-max-width(575px) {
    .notification-center {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/LiveNotifications.vue